import { Link } from 'gatsby';
import React, { useState } from 'react';

import { Navbar, Nav, NavDropdown } from "react-bootstrap";
import 'bootstrap/dist/css/bootstrap.min.css';

const Navbarmenu = () => {
    const hideNav = () => {
        if (window.innerWidth <= 1200) {
            document.querySelector(".animated-icon2").click();
        }
    };

    const toggleTheIcon = () => {
        var icon = document.querySelector(".animated-icon2");
        icon.classList.toggle("open");
    };

    const [isMenu, setisMenu] = useState(false);
    const [isResponsiveclose, setResponsiveclose] = useState(false);
    const toggleClass = () => {
        setisMenu(isMenu === false ? true : false);
        setResponsiveclose(isResponsiveclose === false ? true : false);
    };

    let boxClass = ["main-menu menu-right menuq1"];
    if (isMenu) {
        boxClass.push('menuq2');
    } else {
        boxClass.push('');
    }

    const [isMenuSubMenu, setMenuSubMenu] = useState(false);

    const toggleSubmenu = () => {
        setMenuSubMenu(isMenuSubMenu === false ? true : false);
    };

    let boxClassSubMenu = ["sub__menus"];
    if (isMenuSubMenu) {
        boxClassSubMenu.push('sub__menus__Active');
    } else {
        boxClassSubMenu.push('');
    }



    return (
        <Navbar
            sticky="top"
            id="navbar"
            className="navbar mb-lg-0  header__middle p-0 py-4"
            collapseOnSelect
            bg="white"
            expand="lg"
        >
            <div className=' w-100 d-flex justify-content-between px-3 px-xl-5 py-0'>

                <Link to="/" className="text-decoration-none">
                    <h2 className="mt-2 text-dark mr-0 mr-xl-5 pr-0 pr-sm-5">
                        MartinPetrovicky.cz
                    </h2>
                </Link>
                <Navbar.Toggle
                    onClick={() => { toggleClass(); toggleTheIcon(); }}
                    id="togglerButton"
                    className="navbar-toggler second-button p-0"

                    tabIndex={0}
                >
                    <div className="animated-icon2">
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                </Navbar.Toggle>
            </div>
            <Navbar.Collapse id="basic-navbar-nav ml-auto  header__middle__menus">
                <Nav className="text-center py-2 py-lg-0 align-middle main-nav">
                    <li className="menu-item" >
                        <Link exact activeClassName='is-active' onClick={hideNav} to={`/`}> ÚVOD </Link>
                    </li>
                    <NavDropdown className="menu-item p-0" title="FOCENÍ">
                        <li className='text-center my-3'><Link onClick={hideNav} activeClassName='is-active' to={`/svatby`}>- SVATEBNÍ FOCENÍ</Link> </li>
                        <li className='text-center '><Link onClick={hideNav} activeClassName='is-active' to={`/plesy`}>- MATURITNÍ FOCENÍ</Link> </li>
                        <li className='text-center my-3'> <Link onClick={hideNav} activeClassName='is-active' to={`/vanoce`}>- VÁNOČNÍ FOCENÍ</Link> </li>
                        <li className='text-center mb-3'><Link onClick={hideNav} activeClassName='is-active' to={`/rodinne`}>- RODINNÉ FOCENÍ</Link> </li>
                        <li className='text-center mb-3'><Link onClick={hideNav} activeClassName='is-active' to={`/nemovitosti`}>- NEMOVITOSTI</Link> </li>
                    </NavDropdown>
                    <NavDropdown className="menu-item  p-0" title="VIDEO">
                        <li className='text-center my-3'><Link onClick={hideNav} activeClassName='is-active' to={`/svatbyVideo`}>- SVATEBNÍ VIDEO</Link> </li>
                        <li className='text-center '><Link onClick={hideNav} activeClassName='is-active' to={`/plesyVideo`}>- MATURITNÍ VIDEO</Link> </li>
                    </NavDropdown>
                    <li className="menu-item " ><Link onClick={hideNav} activeClassName='is-active' to={`/reference`}> REFERENCE </Link> </li>
                    <li className="menu-item " ><Link onClick={hideNav} activeClassName='is-active' to={`/kontakt`}> KONTAKT </Link> </li>
                </Nav>
            </Navbar.Collapse>

        </Navbar>
    )
}

export default Navbarmenu
